import { 
  OreButton, 
  OreHeading, 
  OreStack, 
  OreText, 
  SvgRepeat,
  SvgWarning  
} from '@edenredespana/oreneta' 
import { Trans, useTranslation } from 'react-i18next'
import { LoginTranslation } from '@/Account/ui/accountTranslation'
import { formTranslation } from '@/Shared/ui/sharedTranslation'
import { useNavigate } from 'react-router-dom'
import { openNavigationRoutes } from '@/Shared/ui/routers'

export const PasswordResetExpiredToken = (): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <>
      <OreStack placeContent="center" space="large" style={{ maxWidth: '60%', paddingTop: '1rem' }}>
        <OreStack placeItems="center" space="large">
          <img src={SvgWarning} alt="Success" />
          <OreStack space="medium" placeItems="center">
            <OreHeading size="headline-lg">{t(LoginTranslation.recovery.expiredToken.title)}</OreHeading>
            <OreText style={{ whiteSpace: 'pre-line' }} align="center">
              <Trans t={t}>{t(LoginTranslation.recovery.expiredToken.subtitle)}</Trans>
            </OreText>
          </OreStack>
        </OreStack>
        <OreStack placeItems="center" placeContent="center">
          <OreButton
            category="primary"
            icon={<SvgRepeat />}
            iconAlign="right"
            onClick={() => navigate(openNavigationRoutes.passwordRecoveryStep1)}
          >
            {t(formTranslation.common.buttons.tryAgain)}
          </OreButton>
        </OreStack>
      </OreStack>
    </>
  )
}
